// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

:root {
  --index: calc(100vh * 100vw);
}

.header-wrap {
  margin-top: 20px;
}
@media (min-width: 991px) {
  .header-wrap {
    margin-top: 80px;
  }
}

.logo-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: max-content !important;
}
.logo-container .brand-logo {
  margin: 25px auto 32px;
  height: 60px;
}
.logo-container .shop-logo {
  margin-top: 40px;
}
@media (min-width: 991px) {
  .logo-container {
    padding-top: 80px;
    z-index: 1;
  }
}

.separator {
  height: 12px;
  width: 100%;
  background: url('separator_doted_white.svg') no-repeat center center/100% 100%;
}

.title {
  font-size: 30px;
  text-transform: uppercase;
  margin: 20px auto 0px;
  color: white;
}
@media (min-width: 991px) {
  .title {
    margin: 10px auto 0;
    font-size: calc(65px + 35 * (100vw - 1280px) / 640);
  }
}
@media (min-width: 991px) and (max-height: 750px) {
  .title {
    margin: 15px auto 0px;
    font-size: 35px;
  }
}

.subtitle {
  font-size: 30px;
  text-transform: uppercase;
  padding: 0 45px;
  margin-bottom: 20px;
  color: white;
}
@media (min-width: 991px) {
  .subtitle {
    padding: 0px 60px 10px;
    margin-bottom: 15px;
    font-size: calc(14px + 21 * (100vw - 1280px) / 640);
  }
}
@media (min-width: 991px) and (max-height: 750px) {
  .subtitle {
    margin-bottom: 15px;
    font-size: 18px;
  }
}

app-burger-btn {
  color: var(--ion-color-primary) !important;
  padding: 5px 5px 0px;
}

.footer-lang {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 20px;
}
.footer-lang .lang-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
}
.footer-lang .flag {
  height: 12px;
  width: 20px;
}
.footer-lang .lang-p {
  font-family: AppFontBold;
  font-size: 14px;
  line-height: 17px;
  text-align: left;
  color: #2c2c31;
  text-transform: uppercase;
}
.footer-lang .flag_btn {
  display: flex;
  justify-content: center;
  align-items: center;
  --background: #fff;
}

.location_arrow {
  height: 22px;
  margin-right: 14px;
}

.payment_text {
  font-family: AppFontBold;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #fff;
  margin-bottom: 12px;
}

.info-block {
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='black' stroke-width='5' stroke-dasharray='2%2c 8' stroke-dashoffset='50' stroke-linecap='butt'/%3e%3c/svg%3e");
  background-color: #fff;
  display: none;
  justify-content: center;
  align-items: center;
  padding: 30px 40px 20px;
  font-family: AppFont;
  font-size: 14px;
  line-height: 20px;
}
@media (min-width: 991px) {
  .info-block {
    display: flex;
  }
}

.top-card-block {
  display: flex;
  flex-direction: column;
}

.mobile {
  display: none;
}
@media (max-width: 992px) {
  .mobile {
    display: flex !important;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }
}

.desktop {
  display: none;
}
@media (min-width: 991px) {
  .desktop {
    display: block;
  }
}

.bg_desktop_images {
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  width: 100%;
}
@media (max-width: 992px) {
  .bg_desktop_images {
    display: none;
  }
}
.bg_desktop_images ion-img {
  width: 30px;
  height: 30px;
}
.bg_desktop_images .first {
  position: fixed;
  width: 108%;
  height: 121%;
  top: -73%;
  left: -49%;
}
.bg_desktop_images .second {
  position: fixed;
  width: 120%;
  height: 130%;
  bottom: -88%;
  left: -40%;
}
@media (max-width: 1280px) {
  .bg_desktop_images .second {
    width: 106%;
    height: 127%;
  }
}
.bg_desktop_images .third {
  position: fixed;
  width: 56%;
  height: 119%;
  top: -37%;
  right: -27%;
}
.bg_desktop_images .fourth {
  position: fixed;
  width: 30%;
  height: 55%;
  bottom: -21%;
  right: -3%;
}
.bg_desktop_images .fifth {
  position: fixed;
  width: 32%;
  height: 40%;
  bottom: 25%;
  left: -8%;
}
.bg_desktop_images .sixth {
  position: fixed;
  width: 23%;
  height: 42%;
  bottom: -13%;
  left: 51%;
}
@media (max-height: 900px) {
  .bg_desktop_images .sixth {
    bottom: -16%;
    left: 54%;
  }
}

.separator_desktop {
  height: 26px;
  width: 100%;
  background: url('separator_doted2_white.svg') no-repeat center center;
}

.btn-desktop {
  box-sizing: content-box;
  margin-top: 10vh;
  height: 54px;
  --border-radius: 100px;
  --background: var(--ion-color-primary);
  color: #fff;
  font-size: 20px;
  border: 3px solid #fff;
  border-radius: 100px;
}
@media (min-width: 991px) {
  .btn-desktop {
    --padding-start: 3em;
    --padding-end: 3em;
  }
}
.btn-desktop ion-icon {
  zoom: 1.2;
}

.center-block {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between !important;
  height: 40vh;
}
@media (max-width: 992px) {
  .center-block {
    justify-content: flex-end !important;
    margin-top: 0px;
  }
}

.lang-desktop {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
}

.btn-mobile-lang {
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  padding: 5px 10px;
  border-radius: 50px;
  width: 100px;
  margin-top: 10px;
}

.btn {
  border: 1px solid white !important;
  border-radius: 50px;
}

.payment {
  margin-top: 10vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.payment_info {
  font-family: AppFontBold;
  font-size: 18px;
  text-align: center;
  margin-bottom: 12px;
  max-width: 330px;
  color: #fff;
}
@media (min-width: 1281px) {
  .payment_info {
    font-size: 22px;
    max-width: 400px;
  }
}
.payment ion-img {
  width: 80%;
  height: 30px;
}
@media (min-width: 1281px) {
  .payment ion-img {
    height: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/home/home.page.losteria.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AACA;EACC,sBAAA;AAAD;;AAGA;EACC,4BAAA;AAAD;;AAUA;EACC,gBAAA;AAPD;ACTE;EDeF;IAGE,gBAAA;EALA;AACF;;AAOA;EACC,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,6BAAA;AAJD;AAKC;EACC,sBAAA;EACA,YAAA;AAHF;AAKC;EACC,gBAAA;AAHF;AC5BE;EDqBF;IAcE,iBAAA;IACA,UAAA;EAHA;AACF;;AAMA;EACC,YAAA;EACA,WAAA;EACA,8EAAA;AAHD;;AAYA;EACC,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,YAAA;AATD;AC/CE;EDoDF;IAME,mBAAA;IA9CD,mDAAA;EAwCC;AACF;AASE;EAVF;IAWG,qBAAA;IACA,eAAA;EAND;AACF;;AAUA;EACC,eAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AAPD;ACnEE;EDqEF;IAQE,sBAAA;IACA,mBAAA;IAlED,mDAAA;EA6DC;AACF;AAME;EAXF;IAYG,mBAAA;IACA,eAAA;EAHD;AACF;;AAOA;EACC,0CAAA;EACA,oBAAA;AAJD;;AAOA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAJD;AAMC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AAJF;AAOC;EACC,YAAA;EACA,WAAA;AALF;AAQC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,gBAAA;EACA,cAAA;EACA,yBAAA;AAPF;AAUC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AARF;;AAWA;EACC,YAAA;EAEA,kBAAA;AATD;;AAYA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EAEA,kBAAA;EACA,WAAA;EACA,mBAAA;AAVD;;AAaA;EACC,8RAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,oBAAA;EACA,eAAA;EACA,iBAAA;AAXD;AC9IE;ED+IF;IAaE,aAAA;EAVA;AACF;;AAaA;EACC,aAAA;EACA,sBAAA;AAVD;;AAaA;EACC,aAAA;AAVD;ACtJE;ED+JF;IAGE,wBAAA;IACA,sBAAA;IACA,8BAAA;IACA,YAAA;EARA;AACF;;AAUA;EACC,aAAA;AAPD;ACxKE;ED8KF;IAGE,cAAA;EALA;AACF;;AAOA;EACC,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AAJD;AC/KE;ED8KF;IAOE,aAAA;EAFA;AACF;AAGC;EACC,WAAA;EACA,YAAA;AADF;AAIC;EACC,eAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AAFF;AAKC;EACC,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;AAHF;AAKE;EAPD;IAQE,WAAA;IACA,YAAA;EAFD;AACF;AAIC;EACG,eAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;AAFJ;AAIC;EACC,eAAA;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAFJ;AAKC;EACG,eAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;AAHJ;AAMC;EACC,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AAJF;AAKE;EAND;IAOE,YAAA;IACA,SAAA;EAFD;AACF;;AAOA;EACC,YAAA;EACA,WAAA;EACA,qEAAA;AAJD;;AAOA;EACC,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,sCAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,oBAAA;AAJD;ACtQE;EDiQF;IAYE,oBAAA;IACA,kBAAA;EAHA;AACF;AAKC;EACC,SAAA;AAHF;;AAMA;EACC,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EAEA,yCAAA;EACA,YAAA;AAJD;AClRE;ED+QF;IASE,oCAAA;IACA,eAAA;EAFA;AACF;;AAIA;EACC,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;AADD;;AAGA;EACC,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AAAD;;AAEA;EACC,kCAAA;EACA,mBAAA;AACD;;AAEA;EACC,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AACD;AACC;EACC,wBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AACF;AACE;EARD;IASE,eAAA;IACA,gBAAA;EAED;AACF;AACC;EACC,UAAA;EACA,YAAA;AACF;AAAE;EAHD;IAIE,YAAA;EAGD;AACF","sourcesContent":["@import '../../../theme/mixins';\n* {\n\tbox-sizing: border-box;\n}\n\n:root {\n\t--index: calc(100vh * 100vw);\n}\n\n$maxWidth: 1920;\n@mixin adaptiv-font($pcSize, $mobSize) {\n $addSize: $pcSize - $mobSize;\n $maxWidth: $maxWidth - 1280;\n font-size: calc(#{$mobSize + px} + #{$addSize} * ((100vw - 1280px) / #{$maxWidth}));\n}\n\n.header-wrap {\n\tmargin-top: 20px;\n\t@include desktop {\n\t\tmargin-top: 80px;\n\t}\n}\n.logo-container {\n\tdisplay: flex;\n\tjustify-content: center;\n\tflex-direction: column;\n\twidth: max-content!important;\n\t.brand-logo {\n\t\tmargin: 25px auto 32px;\n\t\theight: 60px;\n\t}\n\t.shop-logo {\n\t\tmargin-top: 40px;\n\t}\n\n\t@include desktop {\n\t\tpadding-top: 80px;\n\t\tz-index: 1;\n\t}\n}\n\n.separator {\n\theight: 12px;\n\twidth: 100%;\n\tbackground: url('../../../assets/icon/separator_doted_white.svg') no-repeat center center/ 100% 100%;\n\t// @include desktop {\n\t// \tbackground: url('../../../assets/icon/separator_doted_white.svg') no-repeat center center/ 100% 110%;\n\t// \t@media (max-height: 750px) {\n\t// \t\theight: 11px;\n\t// \t}\n\t// }\n}\n\n.title {\n\tfont-size: 30px;\n\ttext-transform: uppercase;\n\tmargin: 20px auto 0px;\n\tcolor: white;\n\t@include desktop {\n\t\tmargin: 10px auto 0;\n\t\t// font-size: 65px;\n\t\t@include adaptiv-font(100, 65);\n\n\t\t@media (max-height: 750px) {\n\t\t\tmargin: 15px auto 0px;\n\t\t\tfont-size: 35px;\n\t\t}\n\t}\n}\n\n.subtitle {\n\tfont-size: 30px;\n\ttext-transform: uppercase;\n\tpadding: 0 45px;\n\tmargin-bottom: 20px;\n\tcolor: white;\n\n\t@include desktop {\n\t\tpadding: 0px 60px 10px;\n\t\tmargin-bottom: 15px;\n\t\t@include adaptiv-font(35, 14);\n\t\t@media (max-height: 750px) {\n\t\t\tmargin-bottom: 15px;\n\t\t\tfont-size: 18px;\n\t\t}\n\t}\n}\n\napp-burger-btn {\n\tcolor: var(--ion-color-primary) !important;\n\tpadding: 5px 5px 0px;\n}\n\n.footer-lang {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin: 0 auto 20px;\n\n\t.lang-wrapper {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tmargin-right: 5px;\n\t}\n\n\t.flag {\n\t\theight: 12px;\n\t\twidth: 20px;\n\t}\n\n\t.lang-p {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 14px;\n\t\tline-height: 17px;\n\n\t\ttext-align: left;\n\t\tcolor: #2c2c31;\n\t\ttext-transform: uppercase;\n\t}\n\n\t.flag_btn {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\t--background: #fff;\n\t}\n}\n.location_arrow {\n\theight: 22px;\n\t// width: 22px;\n\tmargin-right: 14px;\n}\n\n.payment_text {\n\tfont-family: AppFontBold;\n\tfont-size: 16px;\n\tline-height: 20px;\n\n\ttext-align: center;\n\tcolor: #fff;\n\tmargin-bottom: 12px;\n}\n\n.info-block {\n\tbackground-image: url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='black' stroke-width='5' stroke-dasharray='2%2c 8' stroke-dashoffset='50' stroke-linecap='butt'/%3e%3c/svg%3e\");\n\tbackground-color: #fff;\n\tdisplay: none;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 30px 40px 20px;\n\n\tfont-family: AppFont;\n\tfont-size: 14px;\n\tline-height: 20px;\n\n\t@include desktop {\n\t\tdisplay: flex;\n\t}\n}\n\n.top-card-block {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.mobile {\n\tdisplay: none;\n\t@include mobile {\n\t\tdisplay: flex !important;\n\t\tflex-direction: column;\n\t\tjustify-content: space-between;\n\t\theight: 100%;\n\t}\n}\n.desktop {\n\tdisplay: none;\n\t@include desktop {\n\t\tdisplay: block;\n\t}\n}\n.bg_desktop_images {\n\tposition: fixed;\n\tbottom: 0px;\n\tleft: 0px;\n\tright: 0px;\n\twidth: 100%;\n\t@include mobile {\n\t\tdisplay: none;\n\t}\n\tion-img {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\t// object-fit: fill;\n\t}\n\t.first {\n\t\tposition: fixed;\n\t\twidth: 108%;\n\t\theight: 121%;\n\t\ttop: -73%;\n\t\tleft: -49%;\n\t}\n\n\t.second {\n\t\tposition: fixed;\n\t\twidth: 120%;\n\t\theight: 130%;\n\t\tbottom: -88%;\n\t\tleft: -40%;\n\n\t\t@media (max-width: 1280px) {\n\t\t\twidth: 106%;\n\t\t\theight: 127%;\n\t\t}\n\t}\n\t.third {\n    position: fixed;\n    width: 56%;\n    height: 119%;\n    top: -37%;\n    right: -27%;\n\t}\n\t.fourth {\n\t\tposition: fixed;\n    width: 30%;\n    height: 55%;\n    bottom: -21%;\n    right: -3%;\n\t}\n\n\t.fifth {\n    position: fixed;\n    width: 32%;\n    height: 40%;\n    bottom: 25%;\n    left: -8%;\n\t}\n\n\t.sixth {\n\t\tposition: fixed;\n\t\twidth: 23%;\n\t\theight: 42%;\n\t\tbottom: -13%;\n\t\tleft: 51%;\n\t\t@media (max-height: 900px) {\n\t\t\tbottom: -16%;\n\t\t\tleft: 54%;\n\t\t}\n\t\t// rotate: -90deg;\n\n\t}\n}\n.separator_desktop {\n\theight: 26px;\n\twidth: 100%;\n\tbackground: url('../../../assets/losteria/separator_doted2_white.svg') no-repeat center center;\n}\n\n.btn-desktop {\n\tbox-sizing: content-box;\n\tmargin-top: 10vh;\n\theight: 54px;\n\t--border-radius: 100px;\n\t--background: var(--ion-color-primary);\n\tcolor: #fff;\n\tfont-size: 20px;\n\tborder: 3px solid #fff;\n\tborder-radius: 100px;\n\n\t@include desktop {\n\t\t--padding-start: 3em;\n\t\t--padding-end: 3em;\n\t}\n\n\tion-icon {\n\t\tzoom: 1.2;\n\t}\n}\n.center-block {\n\tmargin-top: 20px;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\n\tjustify-content: space-between !important;\n\theight: 40vh;\n\t@include mobile {\n\t\tjustify-content: flex-end !important;\n\t\tmargin-top: 0px;\n\t}\n}\n.lang-desktop {\n\tposition: absolute;\n\tbottom: 20px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\tz-index: 999;\n}\n.btn-mobile-lang {\n\theight: 30px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground: white;\n\tpadding: 5px 10px;\n\tborder-radius: 50px;\n\twidth: 100px;\n\tmargin-top: 10px;\n}\n.btn {\n\tborder: 1px solid white !important;\n\tborder-radius: 50px;\n}\n\n.payment {\n\tmargin-top: 10vh;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\n\t&_info {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 18px;\n\t\ttext-align: center;\n\t\tmargin-bottom: 12px;\n\t\tmax-width: 330px;\n\t\tcolor: #fff;\n\n\t\t@media (min-width: 1281px) {\n\t\t\tfont-size: 22px;\n\t\t\tmax-width: 400px;\n\t\t}\n\t}\n\n\tion-img {\n\t\twidth: 80%;\n\t\theight: 30px;\n\t\t@media (min-width: 1281px) {\n\t\t\theight: 40px;\n\t\t}\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
